import { useState, useEffect, useContext } from "react";
import { ref, update } from "firebase/database";
import { useSelector } from 'react-redux';
import { selectUsers } from '../store/usersSlice';
import { auth, getUserData, db } from "../../firebase";
import { reauthenticateWithCredential, EmailAuthProvider, updatePassword } from "firebase/auth";
import { ThemeContext } from "../../ThemeContext";

import PasswordChangeModal from "../PasswordChangeModal/PasswordChangeModal";

const AccountSettings = () => {
  const user = useSelector(selectUsers);
  const [ userData, setUserData ] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
    const { theme, setTheme } = useContext(ThemeContext);

  useEffect(() => {
    const userInformation = async() => {
      const results = await getUserData(user.currentUser?.id);
      setUserData(results);
    }
  
     userInformation();
  },[user.currentUser])

  const reauthenticate = async (currentPassword) => {
      const user = auth.currentUser;
      const credential = EmailAuthProvider.credential(
        user.email,
        currentPassword
      );
      
      await reauthenticateWithCredential(user, credential);
    };

  const handlePasswordChange = async (currentPassword, newPassword) => {
    try {
      await reauthenticate(currentPassword);
      await updatePassword(auth.currentUser, newPassword);
      alert("Password changed successfully!");
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  const handleThemeChange = async (newTheme) => {
    setTheme(newTheme);

    // if user is logged in, save preference
    if (user.currentUser) {
      const userRef = ref(db, `users/${user.currentUser.id}`);
      await update(userRef, { theme: newTheme });
    }
  };

  return (
    <>
      <ul>
        <li>
          <button className="mainPageButtons" onClick={() => setModalOpen(true)}>Change Password</button>
        </li>
        <li>
          Theme:{" "}
          <select
            className="mainPageButtons"
            name="themes"
            id="themes"
            value={theme}
            onChange={((e) => handleThemeChange(e.target.value))}
          >
            <option value="original_light">original light</option>
            <option value="original_dark">original dark</option>
          </select>
        </li>
      </ul>
      <PasswordChangeModal 
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handlePasswordChange}
      />
    </>
  )
}

export default AccountSettings;